<div class="min-h-screen">
    <main class="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
        <div class="flex flex-col items-center text-center">
            <!-- Image Container -->
            <div class="mb-12 w-64 max-w-xs sm:w-80">
                <img src="/access-denied.webp" alt="Access restricted illustration" class="mx-auto h-48 w-48 sm:h-64 sm:w-64" />
            </div>

            <!-- Text Content -->
            <div class="max-w-2xl">
                <p class="text-base font-semibold text-blue-600">403</p>
                <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Access Restricted</h1>
                <div class="mt-6 text-base leading-7 text-gray-600 space-y-3">
                    <p class="font-medium">Whoops! It seems you've reached restricted territory.</p>
                    <div class="text-left max-w-xs mx-auto">
                        <ul class="list-disc space-y-2">
                            <li>Your account lacks required permissions</li>
                            <li>Session might have expired</li>
                        </ul>
                    </div>
                    <p class="pt-4">Please contact your administrator, sign in or authenticate with elevated credentials.</p>
                </div>

                <!-- Action Buttons -->
                <div class="mt-10 flex items-center justify-center gap-x-6">
                    @if (auth.isAuthenticated$ | async) {
                        <a
                            href="#"
                            routerLink="/dashboard"
                            class="rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                        >
                            Return to Safety
                        </a>
                        <button
                            (click)="auth.logout({ logoutParams: { returnTo: document.location.origin } })"
                            class="text-sm font-semibold text-gray-900 hover:text-blue-600 transition-colors"
                        >
                            Sign out <span aria-hidden="true">&rarr;</span>
                        </button>
                    } @else {
                        <button
                            (click)="
                                auth.loginWithRedirect({
                                    appState: { target: '/callback' }
                                })
                            "
                            class="text-sm font-semibold text-gray-900 hover:text-blue-600 transition-colors"
                        >
                            Sign in <span aria-hidden="true">&rarr;</span>
                        </button>
                    }
                </div>
            </div>
        </div>
    </main>
</div>
